import React from 'react'
import './Footer.css'
import logo1 from "../components/images/logo1.png"
import { SiMinutemailer } from "react-icons/si";
import { FaLocationDot,FaPhone } from "react-icons/fa6";
import { Link } from 'react-scroll';

const Footer = () => {
    return (<>
        <h1 id='contact_info' ></h1>
        <div className='footer'>
            <div className='right'>
                <Link to='hero'spy={true} smooth={true} offset={-100} duration={500} ><img src={logo1}></img></Link>
            </div>
            <div className='info'>
                <h3 >Contact Info</h3>
                <br/>
                <FaLocationDot/>
                
        <div className='flexy'>
            <div> 
                <p>Pillaiyar Kovil St, Ramachandra Nagar,<br/>
                    Periya Kolathuvancheri, Iyyappanthangal,<br/>
                    Chennai, Tamil Nadu 600056.</p>
            </div>
            <div className='vl'>
            
            </div>

            <div>
            127, Keshavardhini st,<br/> 
            Annai stores, Iyyappanthangal,<br/> 
            Chennai 600056.
            </div> 
            
        </div>   
        
        <br/>

            <FaPhone/>
            <p>
                    +91 9840760338 <br/>
                    +91 9840727121 <br/>
            </p>
            <br/>
            <SiMinutemailer/>
            <p>bsjrealestate@gmail.com</p>

                </div>
            <div className='container'>
                
                <div className='bottom'>
                    <span className='line'></span>
                    <p>Copyright © {new Date().getFullYear()} BSJRealEstate.All rights reserved.</p>
                </div>
            </div>
        </div>
        
        </>
    )
}

export default Footer
